import { object, number } from "yup";

import "./schemas";

const containerFillLevelSchema = object({
  containerThreshold: number().required()
});

export default containerFillLevelSchema;
